module.exports = __webpack_public_path__ + "media/images/pic/courses/00-c8e7e1d92b9629f4519e4c8393889f6d.svg";